<template>
  <div class="program">
    <div class="resolve-tabs">
      <div class="tab-left">
        <div
          class="left-item"
          :class="{ 'active-left': fristSelect == item.id }"
          v-for="(item, index) in tabsObj.leftList"
          :key="item.id"
          @click="changeTabs(item.id, 'left', index)"
        >
          {{ item.title }}
        </div>
      </div>

      <div class="tab-right">
        <div class="title">
          <h2>互联网产品解决方案</h2>
          <p>提供100+行业解决方案，覆盖多样化行业场景，解决您的需求痛点</p>
        </div>
        <div class="top-box">
          <div :class="{ hidden: !isShowImg(fristSelect) }">
            <img
              v-show="!leftActive"
              class="left-img"
              src="../../static/images/home/xiangzuo.png"
              @click.stop="toPreTab(fristSelect)"
            />
            <img
              v-show="leftActive"
              class="left-img"
              src="../../static/images/home/xiangzuo_active.png"
              @click.stop="toPreTab(fristSelect)"
            />
          </div>

          <div
            class="tab-top"
            v-for="item in tabsObj.topList"
            :key="item.select"
            v-show="item.select == fristSelect"
          >
            <div
              v-show="s_index < 4"
              class="top-item"
              v-for="(s_item, s_index) in item.list"
              :key="s_item.id"
              :class="{ 'active-top': secondSelect == s_item.id }"
              @click="changeTabs(s_item.id, 'top')"
            >
              {{ s_item.title }}
            </div>
          </div>

          <div :class="{ hidden: !isShowImg(fristSelect) }">
            <img
              v-show="!rightActive"
              src="../../static/images/home/xiangyou.png"
              @click.stop="toNextTab(fristSelect)"
            />
            <img
              v-show="rightActive"
              src="../../static/images/home/xiangyou_active.png"
              @click.stop="toNextTab(fristSelect)"
            />
          </div>
        </div>

        <div
          class="tab-content"
          v-for="item in tabsObj.contentList"
          :key="item.id"
          v-show="allSelect == item.id"
        >
          <div class="top-flex">
            <div class="aim">
              {{ item.aim }}
            </div>
            <div class="more-btn" @click="jumpPages(item.id)">查看更多</div>
          </div>
          <div class="feature m_flex" v-if="item.fea && item.fea.list.length">
            <div class="feature-right">
              <div
                class="feature-item"
                v-for="(s_item, s_index) in item.fea.list"
                :key="s_index"
                :class="{
                  'big-width': item.id == 'mark-transantion',
                  'middle-width':
                    item.id == 'system-whole' ||
                    item.id == 'system-live' ||
                    item.id == 'education-new',
                  'small-width':
                    item.id == 'industry-mother' ||
                    item.id == 'industry-medicine' ||
                    item.id == 'education-live'
                }"
              >
                <!-- <div>
                  <img :src="s_item.img" />
                </div> -->
                <div class="ct-box">
                  <h2>{{ s_item.title }}</h2>
                  <p>{{ s_item.desc }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="manage" v-if="item.manage && item.manage.list.length">
            <div
              class="row"
              v-for="s_item in item.manage.list"
              :key="s_item.id"
            >
              <div class="ul-title">{{ s_item.title }}</div>
              <div
                class="li-item"
                v-for="d_item in s_item.descList"
                :key="d_item.id"
              >
                {{ d_item.desc }}
              </div>
            </div>
          </div>
          <div class="manage" v-if="item.consume && item.consume.list.length">
            <div
              class="row"
              v-for="s_item in item.consume.list"
              :key="s_item.id"
            >
              <div class="ul-title">{{ s_item.title }}</div>
              <div class="ul-box">
                <div
                  class="li-item"
                  v-for="d_item in s_item.descList"
                  :key="d_item.id"
                >
                  {{ d_item.desc }}
                </div>
              </div>
            </div>
          </div>
          <div class="icon" v-if="item.icon && item.icon.list.length">
            <div
              class="icon-item"
              v-for="(s_item, s_index) in item.icon.list"
              :key="s_index"
            >
              <img :src="s_item.img" />
              <p>{{ s_item.title }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tabsObj: {
        leftList: [
          { id: "system", title: "电商系统解决方案" },
          { id: "industry", title: "电商行业解决方案" },
          // { id: "mark", title: "电商营销系统" },
          { id: "sport", title: "体育行业解决方案" },
          { id: "education", title: "教育系统解决方案" },
          { id: "wisdom", title: "智慧行业" },
        ],
        topList: [
          {
            select: "system",
            list: [
              { id: "whole", title: "B2B批发商城系统" },
              { id: "o2o", title: "O2O在线商城解决方案" },
              { id: "live", title: "直播电商解决方案" },
              { id: "supply", title: "S2B2B2C电商供应链系统" },
              { id: "online", title: "B2B2C在线商城解决方案" },
              { id: "self", title: "B2C自营品牌商城解决方案" },
            ],
          },
          {
            select: "industry",
            list: [
              { id: "mother", title: "母婴电商解决方案" },
              { id: "fresh", title: "生鲜电商解决方案" },
              { id: "medicine", title: "医药电商解决方案" },
            ],
          },
          {
            select: "mark",
            list: [{ id: "hall", title: "智慧售楼系统" }],
          },
          {
            select: "sport",
            list: [
              { id: "fit", title: "健身场管理解决方案" },
              { id: "move", title: "运动健身平台解决方案" },
            ],
          },
          {
            select: "education",
            list: [
              { id: "new", title: "新教育解决方案" },
              { id: "live", title: "直播课程解决方案" },
            ],
          },
          {
            select: "wisdom",
            list: [
              { id: "view", title: "智慧景区解决方案" },
              // { id: "travel", title: "智慧旅游解决方案" },
              // { id: "hotel", title: "智慧酒店解决方案" },
            ],
          },
        ],
        contentList: [
          {
            id: "system-supply",
            aim:
              "构建完美企业级供应链电商体系解决实业+互联网困局为传统实业量身定做",

            fea: {
              list: [
                {
                  title: "创新电商模式",
                  desc:
                    "S2B2B2C是一个创新的电商模式，带来比传统模式更大的价值创新",
                },
                {
                  title: "降低获客成本",
                  desc:
                    "大批量发展渠道商，1对1卖货拿提成，让其将身边所能触及的消费者汇聚",
                },
                {
                  title: "集成采购降低成本",
                  desc:
                    "具备上游供应链供货议价能力，统一大批量采购，降低商品采购成本",
                },
                {
                  title: "供货商自主推广",
                  desc: "供应商在平台自主开店，自然推广，为平台带来更多曝光",
                },
                {
                  title: "购物信任度高",
                  desc:
                    "对于消费者、朋友、家人推荐的商品既保真又便宜，信任度更高",
                },
                {
                  title: "智能化大数据",
                  desc:
                    "各种消费者数据均存储在平台，平台通过专业运营能够让数据发挥更多价值",
                },
              ],
            },
          },
          {
            id: "system-online",
            aim:
              "以丰富的营销功能，精细化的用户运营，解决多商城电商系统引流、推广难题，帮助企业打造生态级B2B2C多商城系统盈利模式。",
            manage: {
              list: [
                {
                  id: 0,
                  title: "店铺管理",
                  descList: [
                    {
                      id: 0,
                      desc: "店铺管理",
                    },
                    {
                      id: 1,
                      desc: "店铺运营",
                    },
                    {
                      id: 2,
                      desc: "续约结算",
                    },
                    {
                      id: 3,
                      desc: "多维度运营数据",
                    },
                    {
                      id: 4,
                      desc: "财务管理",
                    },
                    {
                      id: 5,
                      desc: "类目佣金设置",
                    },
                  ],
                },
                {
                  id: 1,
                  title: "交易管理",
                  descList: [
                    {
                      id: 0,
                      desc: "订单管理",
                    },
                    {
                      id: 1,
                      desc: "退款处理",
                    },
                    {
                      id: 2,
                      desc: "退货处理",
                    },
                    {
                      id: 3,
                      desc: "交易评价",
                    },
                    {
                      id: 4,
                      desc: "交易投诉",
                    },
                    {
                      id: 5,
                      desc: "支付方式",
                    },
                  ],
                },
                {
                  id: 2,
                  title: "分销管理",
                  descList: [
                    { id: 0, desc: "分销页面设置" },
                    {
                      id: 1,
                      desc: "自定义佣金",
                    },
                    {
                      id: 2,
                      desc: "划分代理商等级",
                    },
                    {
                      id: 3,
                      desc: "分销业绩管理",
                    },
                    {
                      id: 4,
                      desc: "分销报表分析",
                    },
                    {
                      id: 5,
                      desc: "销售员管理",
                    },
                  ],
                },
                {
                  id: 3,
                  title: "会员管理",
                  descList: [
                    { id: 0, desc: "会员管理" },
                    {
                      id: 1,
                      desc: "标签管理",
                    },
                    {
                      id: 2,
                      desc: "会员营销",
                    },
                    {
                      id: 3,
                      desc: "会员积分",
                    },
                    {
                      id: 4,
                      desc: "积分规划",
                    },
                    {
                      id: 5,
                      desc: "会员等级",
                    },
                    {
                      id: 6,
                      desc: "会员推广",
                    },
                  ],
                },
                {
                  id: 4,
                  title: "营销管理",
                  descList: [
                    { id: 0, desc: "商家促销工具" },
                    {
                      id: 1,
                      desc: "平台互动营销",
                    },
                    {
                      id: 2,
                      desc: "平台营销专题",
                    },
                    {
                      id: 3,
                      desc: "多维度运营数据",
                    },
                    {
                      id: 4,
                      desc: "分享传播",
                    },
                    {
                      id: 5,
                      desc: "营销效果分析",
                    },
                  ],
                },
                {
                  id: 5,
                  title: "统计管理",
                  descList: [
                    { id: 0, desc: "会员统计" },
                    {
                      id: 1,
                      desc: "店铺统计",
                    },
                    {
                      id: 2,
                      desc: "销量分析",
                    },
                    {
                      id: 3,
                      desc: "转化分析",
                    },
                    {
                      id: 4,
                      desc: "决策支持",
                    },
                  ],
                },
              ],
            },
          },
          {
            id: "system-self",
            aim:
              "构建品牌商、零售商自己的多终端、全渠道线上零售商城助力企业快速进入电商新时代",
            consume: {
              list: [
                {
                  id: 0,
                  title: "消费者",
                  descList: [
                    { id: 0, desc: "会员优惠劵" },
                    { id: 1, desc: "评论分享" },
                    { id: 2, desc: "商品下单" },
                    { id: 3, desc: "礼品劵" },
                    { id: 4, desc: "订单详情" },
                    { id: 5, desc: "LSB定位" },
                    { id: 6, desc: "团购秒杀" },
                    { id: 7, desc: "搜索商品" },
                    { id: 8, desc: "附近门店" },
                    { id: 9, desc: "分销结佣" },
                  ],
                },
                {
                  id: 1,
                  title: "店铺管理员",
                  descList: [
                    { id: 0, desc: "商品管理" },
                    { id: 1, desc: "会员管理" },
                    { id: 2, desc: "售后管理" },
                    { id: 3, desc: "订单管理" },
                    { id: 4, desc: "投诉管理" },
                    { id: 5, desc: "统计管理" },
                    { id: 6, desc: "营销活动管理" },
                    { id: 7, desc: "评价管理" },
                    { id: 8, desc: "店铺管理" },
                    { id: 9, desc: "物流管理" },
                  ],
                },
                {
                  id: 2,
                  title: "平台管理员",
                  descList: [
                    { id: 0, desc: "用户管理" },
                    { id: 1, desc: "商品投诉" },
                    { id: 2, desc: "商城设置" },
                    { id: 3, desc: "入驻审核" },
                    { id: 4, desc: "物流管理" },
                    { id: 5, desc: "财务管理" },
                    { id: 6, desc: "订单管理" },
                    { id: 7, desc: "营销功能" },
                    { id: 8, desc: "商城装修" },
                  ],
                },
              ],
            },
          },
          {
            id: "system-whole",
            aim: "企业之间通过互联网为客提供更好的服务",
            fea: {
              list: [
                {
                  title: "缩短供应链层级",
                  desc:
                    "传统的分销模式为“厂商-总经销-二级批发商-三级批发商-零售商”，每层都有分润，门店拿货成本高。平台通过整合供货商，优质货源能直达门店，增加盈利空间。",
                },
                {
                  title: "数据运营支撑",
                  desc:
                    "供货商可以借助线上平台的销售数据，实现对各渠道门店的分层管理，同时可以适时调整渠道策略，实现以销定采(产)。",
                },
                {
                  title: "解决库存积压难题",
                  desc:
                    "供货商引导原来的采购网点，将传统的收单方式转变为高效的线上模式。另外，平台可以为供货商吸引更多的采购商，从而扩大销售渠道和范围。",
                },
                {
                  title: "经营模式升级",
                  desc:
                    "传统的压货模式会使得供货商或者门店存在不同程度的库存积压供货商可以根据销售数据制定生成/采购计划，门店根据销量情况实现实时采购，减少货物积压。",
                },
              ],
            },
          },
          {
            id: "system-o2o",
            aim:
              "构建品牌商、零售商自己的多终端全渠道线上零售商城，助力企业快速进入电商新时代",
            fea: {
              list: [
                {
                  title: "打通全渠道 实现精准引流",
                  desc:
                    "商家打通各类零售渠道终端，同时对接线上网店、线下实体店、加盟店等，实现数据深度融合，对顾客进行精准画像，实现更有效的智能推送、精准营销、会员留存等。",
                },
                {
                  title: "经营数字化 驱动业务增长",
                  desc:
                    "沉淀商品、会员、营销、交易、服务等数据，为运营决策提供数据依据，实现在线化经营和智能化管理；快速提升企业效率，实现精准化营销和业务增长。",
                },
                {
                  title: "设备物联化 增强卖场体验感",
                  desc:
                    "为了提升经营效率，提升顾客体验感，可在实体店中铺设智能店中店触屏、智能货架、电子价签、智能收银系统、人脸识别、客流统计、VR、直播等物联设备，增强卖场体验感，提升购物便捷性。",
                },
                {
                  title: "线上线下相互连通 形成业务循环",
                  desc:
                    "打通线上线下门店消费场景，在门店体验后，在线上支付；线上下单，线下体验；线下扫码，成为线上会员等。",
                },
                {
                  title: "顾客维护社群化 挖掘潜在需求",
                  desc:
                    "通过现有的商品和服务，让导购、网红等建立强关系顾客圈，精准定位顾客画像，挖掘潜在需求；同时利用顾客社交喜好传播分享，提升品牌知名度及复购率。",
                },
                {
                  title: "供应链社会化 减少库存压力",
                  desc:
                    "各通过卖自己货、别人货、公共货等，或者请人卖，进行货权转移；通过卖现货、卖定制货、预售货、众筹货等，减少库存。",
                },
              ],
            },
          },
          {
            id: "system-live",
            aim: "将线下实体店转到线上，延续互联网优势解决实体店地域限制等难题",
            fea: {
              list: [
                {
                  title: "低成本更便捷的直播互动",
                  desc:
                    "云销城突破商品纯图片展示的局限，满足商家视频直播卖货，增加与消费者更多互动。",
                },
                {
                  title: "借助移动端玩转直播",
                  desc:
                    "供支持在移动端H5、APP上玩转直播，吸引更多用户，引爆平台超高人气流。",
                },
                {
                  title: "吸引更多人气主播",
                  desc:
                    "平台可以招募更多人气主播来提升商品的知名度，让平台拥有更广泛的业务区域。",
                },
                {
                  title: "消费转化逐步提升",
                  desc:
                    "利用直播、短视频的红利时期，有效提升平台的购物消费体验，提高商品交易的转化率。",
                },
              ],
            },
          },
          {
            id: "industry-mother",
            aim:
              "母婴零售商实现实体转型，打通母婴市场线上线下的全渠道服务，拉近和用户的距离",
            fea: {
              list: [
                {
                  title: "导购专属身份",
                  desc: "导购专属二维码，通过绑定客户成为导购专属客户。",
                },
                {
                  title: "导购商品",
                  desc: "设置滞销商品为分润商品，促进商品售卖。",
                },
                {
                  title: "导购激励",
                  desc:
                    "线上下单，专属导购获得分润线下导购开单，导购获得分润。",
                },
                {
                  title: "导购开单",
                  desc: "导购为客户进行开单，带来更多销量。",
                },
                {
                  title: "即时服务",
                  desc: "导购专属客服，一对一专属服务，提升客户消费体验。",
                },
                {
                  title: "业绩指标",
                  desc: "指定销售目标，分配给门店和导购，促进导购积极性。",
                },
                {
                  title: "业绩跟踪",
                  desc: "分配销售指标实时查看销售业绩。",
                },
              ],
            },
          },
          {
            id: "industry-fresh",
            aim:
              "根据行业痛点，专注未生鲜企业提供完善、个性化、定制化的解决方案",
            fea: {
              list: [
                {
                  title: "砍掉中间环节，缩短供应链",
                  desc:
                    "消费者可以先上商城预定自己想要的商品，以需定产，双向透明的运营模式，合理降低成本。",
                },
                {
                  title: "丰富产品的选择，全渠道融合",
                  desc:
                    "一般的生鲜蔬果店，由于占地面积有限，只能摆放几十种产品，通过远丰商城系统可以不限数量。",
                },
                {
                  title: "结合分销，快速推广",
                  desc:
                    "生鲜商城含有一套分销系统，会员可在线上一分钟开启分销二级店铺，分享至好友圈，快速分销。",
                },
                {
                  title: "基于用户、消费者大数据的精准营销",
                  desc:
                    "通过商城的大数据分析，预测消费者需求，使用商城后台多种促销手段吸引消费者购买。",
                },
                {
                  title: "在线商城线上线下协作",
                  desc:
                    "线上线下数据打通，通过生鲜品牌商城让客户（会员）成为公司的资产，线下实体店获取客户信息进行引导销售，目标客户群发送指定门店的促销信息。",
                },
                {
                  title: "无缝对接、一体化管理",
                  desc:
                    "通过ERP、门店POS对接、电商平台的一体化管理，同时把控门店、会员、供应链以及线上电商业务，实现标准化、低成本、高效率。",
                },
              ],
            },
          },
          {
            id: "industry-medicine",
            aim:
              "为消费者提供医药一站式的网上电商平台，支持多个渠道购买，同时提供健康服务的在线支持",
            fea: {
              list: [
                {
                  title: "多商户管理",
                  desc:
                    "自营店铺、入驻店铺等商家经营单位的业务、财务独立核算。",
                },
                {
                  title: "多供应商管理",
                  desc: "支持供应商入驻平台、供诊所、消费个人采购。",
                },
                {
                  title: "在线指派任务",
                  desc: "将任务指派给诊所，医药代表在线进行医生拜访。",
                },
                {
                  title: "采购销售、库存管",
                  desc: "管理者随时查看所有经销商、门店进销存数据。",
                },
                {
                  title: "销售人员定位查看",
                  desc:
                    "选派距离客户位置近的售后人员及时上门，提高人员调动效率，方便管理者随时了解。",
                },
                {
                  title: "会员打通",
                  desc:
                    "线上线下会员信息实时同步，多维度多渠道获取会员信息，打造品牌度与信任度。",
                },
                {
                  title: "多样营销模式",
                  desc:
                    "结合大数据分析，让线上平台为每一位消费者量身定制产品、服务和优惠活动。",
                },
              ],
            },
          },
          {
            id: "education-new",
            aim:
              "可以自定义客户运营流程，基于客户的标签与行为，自动触发针对性的运营跟进流程。打通前后端系统工具，捕捉从注册到成单的行为闭环，识别关键行为，在合适的时机对客户进行转化。",
            fea: {
              list: [
                {
                  title: "全链路广告效果监测，降低引流成本",
                  desc:
                    "整合所有投放渠道数据，完成从流量到转化交易全流程广告效果监测，帮助教育企业了解每一分的投放费用产生的价值，甄别高效投放渠道、创意、关键字等，帮助执行更精准的广告投放，从而降低引流成本。",
                },
                {
                  title: "对接运营工具，整合全渠道客户数据",
                  desc:
                    "用户只需几个点击，即可帮助企业从各类客户触点中取得客户数据，并沉淀下来。",
                },
                {
                  title: "潜客自动化培育与精准营销",
                  desc:
                    "可以自定义客户运营流程，基于客户的标签与行为，自动触发针对性的运营跟进流程。打通前后端系统工具，捕捉从注册到成单的行为闭环，识别关键行为，在合适的时机对客户进行转化。",
                },
                {
                  title: "裂变营销，激活存量用户",
                  desc:
                    "通过成熟的SDK技术，实时追踪裂变全链路数据，帮助企业盘活存量用户，破局用户增长瓶颈，进一步降低客户获取成本。",
                },
              ],
            },
          },
          {
            id: "education-live",
            aim:
              "以直播实时互动、点播资源沉淀为特色，为K12体制内管理者、教师、学生提供全方位的教学、管理和运营服务，使课内教学与课外学习融为一体。通过大数据分析进行诊断，为学生制定个性化的课程和学习路径，实现因材施教。重在培养学生自主学习的能力，最终实现个性化学习",
            fea: {
              list: [
                {
                  title: "教育管理者",
                  desc:
                    "组织名师开展网络课堂，满足学生、家长课后辅导需求，更大范围共享名师资源。",
                },
                {
                  title: "教师",
                  desc:
                    "突破空间限制，提高教学效果；利用丰富的课堂教学工具，制定高效教学计划。",
                },
                {
                  title: "学生",
                  desc: "将大数据分析学习情况，自主选择课程，实现个性化学习。",
                },
                {
                  title: "家长",
                  desc: "减轻家庭经济负担，可陪伴教学，切实了解孩子学习效果。",
                },
              ],
            },
          },
          {
            id: "wisdom-view",
            aim:
              "为景区建设一套线上、线下相结合的信息化综合服务系统，全面提升景区信息化水平，优化景区业务流程，提高运营管理效率，提升游客旅游体验；同时，利用大数据分析为景区的运行监控、旅游安全、应急智慧等方面提供数据依据",
            fea: {
              list: [
                {
                  title: "创新营销 提升盈利",
                  desc:
                    "线上线下自动引流，多渠道推广，采用全新营销手段，大幅提升景区收入。",
                },
                {
                  title: "高效信息化系统 提高景区业务能力",
                  desc:
                    "高效整合信息化系统，实现服务，营销，管理的智慧化，采用智能广播，视频监控，预警与应急指挥调度，提高快速处理突发事件的能力。",
                },
                {
                  title: "沉淀消费者 建立消费数据模型",
                  desc:
                    "对沉淀游客的消费行为、消费足迹，建立游客数据模型，自动识别不同消费能力的潜在游客。",
                },
                {
                  title: "二维码消费 实现高效经营",
                  desc:
                    "游客通过微信扫描二维码进行消费，所有资金直接进入景区账户，景区可自行投资旅游产品或项目通过系统有效的管理和经营。",
                },
                {
                  title: "创新技术 一站式智慧旅游",
                  desc:
                    "利用新的互联网思维和技术，结合景区自身特点定制适合的景区电商平台，实现游客网络购票，720全景，语音解说，一键导航等一站式智慧旅游服务。",
                },
              ],
            },
          },
          {
            id: "wisdom-travel",
            aim: "777",
          },
          {
            id: "wisdom-hotel",
            aim: "777",
          },
          {
            id: "sport-fit",
            aim:
              "一套系统，打通健身房管理所有环节（降低管理成本，提高运营效率，提升品牌形象）",
            fea: {
              list: [
                {
                  title: "稳定好用的管理系统，营销获客更简单",
                  desc:
                    "全新的微服务架构，保障系统7*24小时稳定运行无异常，不再担心数据出错和丢失，灵活扩展，完美适用各种营销场景。",
                },
                {
                  title: "强大的会员卡管理功能",
                  desc:
                    "精心打造的会员卡管理模块，涵盖行业内所有场景，强大的管理功能，灵活的规则设置，满足从单店到品牌连锁的任何需求。",
                },
                {
                  title: "1秒预约，5秒消课，拒绝混乱",
                  desc:
                    "系统数字化管理，搭配人脸识别认证，课程安排看得见，课程业绩算得清，避免私教管理混乱，消课有据可依，业绩有账可查。",
                },
                {
                  title: "健身数字化，让变化看得见",
                  desc:
                    "健身设备智能化，运动数据及时推送，与运动专业人士深度合作，数据内容科学直观。结合私教服务探索更多服务模式，提升服务专业性。",
                },
                {
                  title: "营收分析，1分钱也不会出错",
                  desc:
                    "财务系统参照支付宝设计并针对行业优化适配，熟悉的操作界面5秒上手，关键数据一览无余，搭配精确无误的统计功能，营收统计省心省力。",
                },
                {
                  title: "提升服务质量，强化品牌形象",
                  desc:
                    "丰富的智能设备，提升场馆全方位的使用体验，并且降低运营成本，打造品牌独特竞争力。",
                },
              ],
            },
          },
          {
            id: "sport-move",
            aim:
              "一套系统，打通健身房管理所有环节（降低管理成本，提高运营效率，提升品牌形象）",
            icon: {
              list: [
                {
                  title: "运动记录",
                  img: require("../../static/images/home/1.png"),
                },
                {
                  title: "数据管理",
                  img: require("../../static/images/home/2.png"),
                },
                {
                  title: "场地预约",
                  img: require("../../static/images/home/3.png"),
                },
                {
                  title: "健康目标",
                  img: require("../../static/images/home/4.png"),
                },
                {
                  title: "视频健身",
                  img: require("../../static/images/home/5.png"),
                },
                {
                  title: "晒运动",
                  img: require("../../static/images/home/6.png"),
                },
                {
                  title: "打卡运动",
                  img: require("../../static/images/home/7.png"),
                },
                {
                  title: "互动社区",
                  img: require("../../static/images/home/8.png"),
                },
              ],
            },
          },
        ],
      },
      fristSelect: "system",
      secondSelect: "whole",
      allSelect: "system-whole",
      leftIndex: 0,
      clickNextNum: 0,
      leftActive: false,
      rightActive: true,
    };
  },
  methods: {
    jumpPages(str) {
      let type = str.split("-")[1];
      if (type == "spread" || type == "case" || type == "channel") {
        this.$router.push("/wisdomMarket/" + type);
      } else if (
        type == "mother" ||
        type == "live" ||
        type == "whole" ||
        type == "fresh" ||
        type == "medicine" ||
        type == "o2o"
      ) {
        this.$router.push("/solution/" + type);
      } else {
        this.$addConsult()
      }
    },
    changeTabs(id, type, index) {
      if (type == "left") {
        this.fristSelect = id;
        if (this.leftIndex != index) {
          switch (index) {
            case 0:
              this.secondSelect = "supply";
              break;
            case 1:
              this.secondSelect = "mother";
              break;
            case 2:
              this.secondSelect = "fit";
              break;
            case 3:
              this.secondSelect = "new";
              break;
            case 4:
              this.secondSelect = "view";
              break;
          }
          this.leftIndex = index;
        }
        this.allSelect = id + "-" + this.secondSelect;
      } else if (type == "top") {
        this.secondSelect = id;
        this.allSelect = this.fristSelect + "-" + id;
      }
    },
    toNextTab(fatherId) {
      let indexLenght = 0;
      this.tabsObj.topList.map((item) => {
        if (item.select == fatherId) {
          indexLenght = item.list.length;
          if (4 + this.clickNextNum < indexLenght) {
            this.leftActive = true;
            ++this.clickNextNum;
            --this.clickPreNum;
            let frist = item.list[0];
            item.list.shift();
            item.list.push(frist);
          } else if (4 + this.clickNextNum == indexLenght) {
            this.rightActive = false;
          }
          return;
        }
      });
    },
    toPreTab(fatherId) {
      this.tabsObj.topList.map((item) => {
        if (item.select == fatherId) {
          if (this.clickNextNum > 0) {
            this.rightActive = true;
            --this.clickNextNum;
            ++this.clickPreNum;
            let last = item.list[item.list.length - 1];
            item.list.unshift(last);
            item.list.pop();
          } else if (this.clickNextNum == 0) {
            this.leftActive = false;
          }
          return;
        }
      });
    },
    isShowImg(fatherId) {
      let indexLenght = 0;
      this.tabsObj.topList.map((item, index) => {
        if (item.select == fatherId) {
          indexLenght = item.list.length;
        }
      });
      return indexLenght >= 4 ? true : false;
    },
  },

  watch: {},
};
</script>
<style lang="stylus" scoped>
.program {
  width: 100%;
  height: 746px;
  background-color: #343433;

  .title {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;

    p {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 28px;
      margin-top: 24px;
    }

    h2 {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
    }

    .line {
      width: 42px;
      height: 2px;
      background: #FFC000;
      border-radius: 1px;
      margin-top: 29px;
    }
  }

  .resolve-tabs {
    display: flex;
    justify-content: flex-start;

    .tab-left {
      box-sizing: border-box;
      padding: 230px 0 0 260px;
      width: 480px;
      height: 746px;
      background: url('../../static/images/home/left_bg.png') no-repeat;
    }

    .tab-right {
      width: 1140px;
      margin-top: 48px;
    }

    .left-item.active-left {
      border-left: 2px solid #FFC000;
    }
    .left-item:hover{
      color:#fff;
    }

    .top-item.active-top:after {
      content: '';
      position: absolute;
      bottom: -30px;
      width: 60%;
      height: 2px;
      background: #FFC000;
    }

    .top-box {
      display: flex;
      align-items: center;
      margin-top: 47px;
      width: 1300px;
      overflow: hidden;

      img {
        margin-bottom: 19px;
        z-index: 9;
      }

      img.left-img {
        margin-left: 38px;
      }

      .hidden {
        visibility: hidden;
      }
    }

    .tab-top {
      display: flex;
      padding-bottom: 29px;
      margin: 0 32px 0;
      border-bottom: 1px solid #585858;
      min-width: 1000px;
    }

    .left-item, .top-item {
      position: relative;
      font-size: 18px;
      font-weight: 500;
      color: #BFBFBF;
      cursor: pointer;
    }

    .active-left {
      font-family: PingFang SC;
      font-weight: 800;
      color: #FFFFFF;
    }

    .active-top {
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #FFC000;
    }

    .left-item {
      box-sizing: border-box;
      min-width: 220px;
      padding: 0 0 0 14px;
      margin-bottom: 67px;
    }

    .top-item {
      display: flex;
      padding: 0 28px 0 29px;
    }
    .top-item:hover{
        color: #FFC000;
    }

    .spread-top {
      width: 1005px;
      height: 1px;
      background: #585858;
      margin-left: 32px;
    }

    .tab-content {
      position: relative;
      margin: 25px 0 0 60px;

      .more-btn {
        // position: absolute;
        // top: -10px;
        // right: 80px;
        min-width: 107px;
        height: 40px;
        background: #EDB50B;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        text-align: center;
        line-height: 40px;
        cursor: pointer;
        margin-left: 81px;
        margin-right: 50px;
      }

      .aim {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 30px;
        text-align: justify;
        margin-bottom: 31px;
      }

      .top-flex {
        display: flex;
        justify-content: space-between;
      }

      .m_flex {
        display: flex;
        flex-wrap: wrap;
      }

      .adv {
        .adv-right {
          display: flex;
          flex-wrap: wrap;
          width: 800px;
        }
      }

      .content-title {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #E5E5E5;
        margin-right: 42px;
      }

      .content-item {
        align-items: center;
        margin: 0 56px 23px 0;

        p {
          height: 16px;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #FFFFFF;
          margin-left: 6px;
        }
      }

      .feature {
        margin-top: 18px;
      }

      .feature-right {
        display: flex;
        align-items: flex-start;
        width: 1080px;
        flex-wrap: wrap;
      }

      .feature-item {
        display: flex;
        align-items: flex-start;
        margin-bottom: 23px;
        padding-right: 50px;
        box-sizing: border-box;
        width: 33.33%;

        .ct-box {
          margin-left: 8px;

          h2 {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 800;
            color: #FFFFFF;
            margin-bottom: 17px;
          }

          p {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #BFBFBF;
            line-height: 20px;
            margin-left: 0;
          }
        }
      }

      .icon {
        display: flex;

        .icon-item {
          margin-right: 70px;
        }

        p {
          margin-top: 14px;
          font-size: 18px;
          font-weight: bold;
          color: #FFFFFF;
          line-height: 28px;
        }
      }

      .big-width {
        width: 80%;
      }

      .middle-width {
        width: 50%;
      }

      .small-width {
        width: 23%;
      }
    }
  }

  .manage {
    display: flex;

    .ul-title {
      position: relative;
      width: 180px;
      padding-left: 10px;
      text-align: left;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #FFFFFF;
      margin-bottom: 28px;
    }

    .ul-title::before {
      position: absolute;
      content: '';
      left: -6px;
      top: 3px;
      width: 2px;
      height: 14px;
      background: #FFFFFF;
      border-radius: 1px;
    }

    .ul-box {
      display: flex;
      width: 280px;
      flex-wrap: wrap;
    }

    .li-item {
      position: relative;
      margin-bottom: 21px;
      font-size: 14px;
      width: 102px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.6);
      margin-left: 30px;
    }

    .li-item::before {
      position: absolute;
      content: '';
      left: -20px;
      top: 6px;
      width: 6px;
      height: 6px;
      background: rgba(255, 255, 255, 0.6);
      transform: rotate(45deg);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pc/HomeProgram.vue